module.exports = __webpack_public_path__ + "static/recording-elements2-9a6e394d3ce3d29c47450118f282f7db.png";